<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd10">
      <div id="search-land">
        <h3 class="title">
          Danh sách vựa thu mua
        </h3>
        <div class="row">
          <div class="col-md-4">
            <p
              class="mobile-search-toggle visible-xs"
              v-on:click="hide_mobile = !hide_mobile"
            >
              {{ "Search" | translate }}
              <i class="fas fa-angle-down" v-if="hide_mobile"></i>
              <i class="fas fa-angle-up" v-if="!hide_mobile"></i>
            </p>
            <div
              class="search-controls mt10"
              v-bind:class="{ 'hidden-xs': hide_mobile }"
            >
              <div class="panel panel-default">
                <!-- begin panel-body -->
                <div class="panel-body">
                  <form v-on:submit.prevent="doSearch">
                    <selectlocation
                      :item_class="'col-md-12 col-xs-12 col-sm-6'"
                      :province="search_params.province_id"
                      :district="search_params.district_id"
                      :commune="search_params.commune_id"
                      :is_required="false"
                      :is_get_location="false"
                      @updateLocation="updateLocation"
                    ></selectlocation>

                    <div class="row">
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="input-group wrap-query">
                          <input
                            type="text"
                            class="search-query form-control"
                            placeholder="Từ khóa"
                            v-model="search_params.keyword"
                          />
                          <span class="input-group-btn">
                            <button
                              class="btn btn-danger transparent"
                              type="button"
                            >
                              <span class="glyphicon glyphicon-search"></span>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- end row -->
                    <div class="mt20"></div>
                    <div class="row">

                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <select
                            class="form-control"
                            v-model="search_params.product_id"
                          >
                            <option value>
                              Tất cả sản phẩm...
                            </option>
                            <option
                              v-for="product in products"
                              :value="product.id"
                              :key="product.id"
                            >
                              {{ product.name }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-12 col-xs-12 col-sm-6 mt10">
                        <button
                          type="submit"
                          class="btn btn-success full-width"
                        >
                          <i class="fas fa-search"></i>
                          {{ "Search" | translate }}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <!-- end panel-body -->
              </div>
            </div>
            <!-- end search controls -->
          </div>
          <div class="col-md-8">
            <div class="list-results">
              <loading
                class="mt10"
                :text="'Please wait' | translate"
                v-if="list_items === null"
              ></loading>
              <p
                class="mt10 alert alert-info"
                v-if="list_items && list_items.length == 0"
              >
                {{ "No result" | translate }}
              </p>
              <div v-if="list_items && list_items.length > 0">
                <div class="item" v-for="item in list_items" :key="item.id">
                  <div class="image">
                    <img
                      v-if="!item.banner_image"
                      src="static/images/no-photo.jpg"
                    />
                    <img v-else :src="item.banner_image.thumb_path" />

                  </div>
                  <div class="item-body">
                    <router-link
                      :to="{
                        name: 'ProfileStore',
                        params: { storeId: item.code }
                      }"
                      ><h4>{{ item.name }}</h4></router-link
                    >
                    <a  :href="'tel:'+ item.phone">
                        <i class="fas fa-phone"></i>
                        {{item.phone}}
                    </a>

                    <p class="address"><i class="fas fa-map-marker-alt"></i> {{ item.full_address }}</p>
                    <!-- <div class="meta">
                      <p>{{ item.created_at | moment("from", "now") }}</p>
                    </div> -->
                  </div>

                </div>
                <!-- end .item  -->
                <paginate
                  v-if="total_page > 1"
                  :page-count="total_page"
                  :click-handler="clickPage"
                  :prev-text="'Prev' | translate"
                  :next-text="'Next' | translate"
                  v-model="page"
                  :container-class="'pagination'"
                ></paginate>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end search-land -->

    </div>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import Config from '@/helpers/config'
import MyHeader from '@/components/Layout/Header'
import Paginate from 'vuejs-paginate'
import Loading from '@/components/elements/Loading'

import selectlocation from '@/components/elements/SelectLocation'

export default {
  name: 'FindLand',
  components: {
    MyHeader,
    Paginate,
    Loading,

    selectlocation
  },
  data () {
    return {
      user: null,
      list_items: null,
      hide_mobile: true,
      variants: [],
      page: 1,
      total_page: 1,
      show_form: false,
      pass_data: null,
      products: [],
      search_params: {
        is_packager: 1,
        limit: Utils.getLimit(),
        province_id: '',
        district_id: '',
        commune_id: '',
        from_site: Config.domain,
        product_id: '',
        page: 1

      }
    }
  },
  methods: {
    getProduct () {
      Utils.getAllProducts(this, {}).then((products) => {
        this.products = products.filter(item => {
          for (var i = 0; i < Config.siteProductNames.length; i++) {
            if (item.name.indexOf(Config.siteProductNames[i]) === 0) {
              return true
            }
          }
          return false
        })
      })
    },
    doSearch () {
      this.search_params.page = this.page
      this.search()
    },
    updateLocation (data) {
      console.log('data', data)
      for (let key in data) {
        this.search_params[key] = data[key]
      }
    },
    search () {
      this.list_items = null
      Utils.requestV2(this, true)
        .get(
          `/public-stores/?${Utils.arrayToRequestParam(this.search_params)}`
        )
        .then((response) => {
          let data = response.data

          let list = data.data

          this.list_items = list
          this.total_page = Utils.getTotalPages(data.total)
        })
        .catch((error) => {
          this.updating = false
          Utils.showErrorMessage(this, error.response)
        })
    },
    toCommas (value) {
      return Utils.toCommas(value)
    },
    clickPage (pageNum) {
      this.search_params.page = pageNum
      this.search()
    }
  },
  mounted () {
    this.user = Utils.getUser(this)
    this.getProduct()
    this.search()
  }
}
</script>

<style>
.search-controls .select-location-element label {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Store/SearchPackagerStore.vue